import React from "react";
import {
  ABreadcrumb,
  AButton,
  AEmptyState,
  AIcon,
  APanel
} from "@cisco-sbg-ui/magna-react";
import {appConfig} from "config/defaultConfig";
import {t} from "i18next";
import {Link} from "react-router-dom";
import IncidentDetailTabs from "./IncidentDetailTabs";
import css from "./IncidentNotFound.module.scss";

const {ROUTES} = appConfig.APP;

const IncidentNotFound = ({id}) => (
  <>
    <ABreadcrumb
      style={{marginBottom: 20, padding: 0}}
      items={[
        {
          component: Link,
          content: t("breadcrumb.incidents"),
          contentProps: {
            to: ROUTES.INCIDENTS
          }
        }
      ]}
    />
    <h1>{id}</h1>
    <IncidentDetailTabs />
    <APanel style={{padding: "50px 0 200px"}} className="mx-0">
      <div
        className={css.incidentNotFound}
        data-testid={"IncidentNotFound-Container"}>
        <AEmptyState variant="positive" large />
        <h2 style={{marginBottom: 20}}>{t("incidentDetail.detail.noData")}</h2>
        <p style={{marginBottom: 50}}>
          {t("incidentDetail.detail.mayHaveBeenDeleted")}
        </p>
        <AButton medium component={Link} to={ROUTES.INCIDENTS} tertiary>
          <AIcon size="small" left>
            arrow-left
          </AIcon>
          <span>{t("incidentDetail.detail.returnToIncidentList")}</span>
        </AButton>
      </div>
    </APanel>
  </>
);

export default IncidentNotFound;
